import { useQuery } from 'react-query';
import { AlumnoType, UserType } from '../types/types';
import hash from 'object-hash';

const baseRoute = process.env.REACT_APP_BASE_URL;

async function alumnosApiCall(user?: UserType | null, inactivos?: boolean, verHistorico?: boolean, anio?: number) {
  if (!user?.token) return null;
  const headers = {
    'Authorization': `Bearer ${user.token}`,
  };

  let params = '';

  if (inactivos) {
    params += '?inactivos=true';
  }

  if (verHistorico) {
    if (params.length > 0) {
      params += '&verHistorico=true';
    } else {
      params += '?verHistorico=true';
    }
  }

  if (anio) {
    if (params.length > 0) {
      params += `&anio=${anio}`;
    } else {
      params += `?anio=${anio}`;
    }
  }

  const url = `${baseRoute}/api/alumnos${params}`;

  const response = await fetch(url, { headers, method: 'GET' });

  if (!response.ok) {
    throw new Error('Problem fetching data');
  }

  const resp = await response.json();
  return resp as AlumnoType[];
}

export async function alumnoApiCall(user?: UserType | null, id?: string) {
  if (!user?.token) return null;
  const headers = {
    'Authorization': `Bearer ${user.token}`,
  };

  const url = `${baseRoute}/api/alumno?id=${id}`;
  const response = await fetch(url, { headers, method: 'GET' });

  if (!response.ok) {
    throw new Error('Problem fetching data');
  }

  const resp = await response.json();
  return resp as AlumnoType;
}


export function useGetAlumnos(user?: UserType | null, inactivos?: boolean, verHistoricos?: boolean, anio?: number) {
  return useQuery<AlumnoType[] | null, Error>(
    ['getAlumnos', hash(user ?? ''), inactivos, verHistoricos, anio],
    () => alumnosApiCall(user, inactivos, verHistoricos, anio), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}

export function useGetAlumno(user?: UserType | null,  id?: string) {
  return useQuery<AlumnoType | null, Error>(
    ['getAlumno', hash(user ?? ''), id],
    () => alumnoApiCall(user, id), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}